// api.js
import axios from "axios";
import {
    NotificationManager } from "react-notifications";
import {
  SUCCESS,
  NOITEMSAVAILABLE,
  NODATA,
  isEmpty,
  printInfoLog,
  AXIOS_TIMEOUT
} from "../../constants/constant";

const snpAxios = axios.create({
    timeout: AXIOS_TIMEOUT,
    headers: { "Content-Type": "application/json" },
});

// this will be set by SnpWrapper once
let globalErrorHandler = null;

export const setGlobalErrorHandler = (handler) => {
    globalErrorHandler = handler;
};

// Axios interceptors
snpAxios.interceptors.response.use(
    (response) => {
        const { status, errorMessage } = response.data;

        if (status === SUCCESS || status === NOITEMSAVAILABLE) {
            return response;
        } else if (status === NODATA) {
            NotificationManager.warning(
                <p style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}>
                    {isEmpty(errorMessage) ? "No Data Available" : errorMessage}
                </p>
            );
            return response;
        } else {
            if (globalErrorHandler) {
                const result = globalErrorHandler(response, status, errorMessage);
                if (!result.throw) {
                    return response;
                } else {
                    throw new Error(result.data);
                }
            }
            throw new Error(errorMessage || "Unknown error");
        }
    },
    (error) => {
        if (error.response) {
            printInfoLog("GlobalReq error", error.response.data);
            const { status, errorMessage } = error.response.data;
            if (globalErrorHandler) {
                const result = globalErrorHandler(null, status, errorMessage);
                if (result.throw) {
                    throw new Error(result.data);
                }
            }
            throw error;
        } else if (error.data) {
            printInfoLog("GlobalReq error(error.data)", error.data);
            const { status, errorMessage } = error.data;
            if (globalErrorHandler) {
                const result = globalErrorHandler(null, status, errorMessage);
                if (result.throw) {
                    throw new Error(result.data);
                }
            }
            throw error;
        } else {
            printInfoLog("GlobalReq deferror", error);
            if (globalErrorHandler) {
                const result = globalErrorHandler(null, 0, "Unknown error");
                if (result.throw) {
                    throw new Error(result.data);
                }
            }
            throw error;
        }
    }
);

export { snpAxios };
